import { TextSecondary } from '@cycle-app/ui';
import { useTheme } from 'styled-components';

import light from './customer-dashbboard.png';
import dark from './customer-dashboard-dark.png';
import { Title, Container, Image, ImageContainer } from './OnboardingCustomerDashboard.styles';

export const OnboardingCustomerDashboard = () => {
  const { isDark } = useTheme();
  return (
    <Container>
      <Title>Customer voice dashboard</Title>
      <TextSecondary $mt="4px">Get an in-deph view of your insights</TextSecondary>
      <ImageContainer>
        <Image src={isDark ? dark : light} alt="" />
      </ImageContainer>
    </Container>
  );
};
